import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Progress } from '../ui/progress';
import { cn } from '../../lib/utils';

function SystemHealth({ stats }) {
  const monitorStats = stats?.monitor_stats || {};
  const storageUsed = stats?.storage_percent || 0;
  const onlineWorkers = stats?.online_workers || 0;
  const totalWorkers = stats?.total_workers || 0;

  const monitors = [
    { name: 'Screenshots', active: (monitorStats.screenshots || 0) > 0, count: monitorStats.screenshots || 0 },
    { name: 'Clipboard', active: (monitorStats.clipboard || 0) > 0, count: monitorStats.clipboard || 0 },
    { name: 'Applications', active: (monitorStats.applications || 0) > 0, count: monitorStats.applications || 0 },
    { name: 'USB Devices', active: (monitorStats.usb_devices || 0) > 0, count: monitorStats.usb_devices || 0 },
  ];

  const storageIndicator =
    storageUsed > 80 ? 'bg-destructive' : storageUsed > 50 ? 'bg-warning' : 'bg-primary';

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">System Health</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <div className="text-xs text-muted-foreground">Workers Online</div>
          <div className="text-3xl font-bold text-foreground tabular-nums">
            {onlineWorkers} / {totalWorkers}
          </div>
          {totalWorkers === 0 && (
            <div className="text-xs text-warning">No workers registered yet</div>
          )}
        </div>

        <div>
          <div className="text-xs text-muted-foreground mb-2">Active Monitors</div>
          <div className="flex flex-wrap gap-1.5">
            {monitors.map((monitor) => {
              const Icon = monitor.active ? CheckCircle2 : XCircle;
              return (
                <Badge
                  key={monitor.name}
                  variant={monitor.active ? 'success' : 'outline'}
                >
                  <Icon className="h-3 w-3" />
                  {monitor.name} ({monitor.count})
                </Badge>
              );
            })}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-1">
            <span className="text-xs text-muted-foreground">Storage Used</span>
            <span className="text-xs text-muted-foreground">{storageUsed}%</span>
          </div>
          <Progress value={storageUsed} indicatorClassName={cn(storageIndicator)} />
          <div className="text-xs text-muted-foreground mt-1">
            Based on {(monitorStats.screenshots || 0) + (monitorStats.clipboard || 0)} data files
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default SystemHealth;
